import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, ActivatedRoute } from '@angular/router';
import { ScrumboardService } from '../../scrumboard.service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit {

  selectedDate = new Date();
  membersIds = [];
  graphValue: any;
  workDetail = [];
  totalWorkHours = '';
  activities = [];
  projectId: any;
  projectName: any;
  private _unsubscribeAll: Subject<any>;
  board: any;
  last15days = [];
  listOfSprintIds = [];
  public barChartOptions = {
    scales: {
      xAxes: [{
        ticks: {
          stepSize: 2,
          beginAtZero: true
        }
      }]
    }
  }
  back = false;

  constructor(private spinner: NgxSpinnerService,
    private router: Router,
    private _scrumboardService: ScrumboardService,
    private route: ActivatedRoute,
    private parseService: ParseService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private queryInterface: QueryInterface, ) { }

  ngOnInit() {

    this.Last15Days();
    this.route.params.subscribe(async params => {
      this.projectId = params.boardId;
      this.projectName = params.boardUri;
      await this.getSprintList();
      this.getActivities();
      await this.getProMembers();
      this.getWorkHours();
    });

    this._scrumboardService.onBoardChanged
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(board => {
        this.board = board;
      });

  }

  async getSprintList() {
    this.listOfSprintIds = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    await query.find().then(results => {
      results.forEach(async element => {
        this.listOfSprintIds.push(element.id);
      });
    });
  }

  async getProMembers() {
    this.membersIds = [];
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('user');
    query.include('user.profile');
    query.equalTo('status', 'Assigned');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    query.limit(500000);
    await query.find().then(results => {
      results.forEach(element => {
        this.membersIds.push(element.get('user').id);
      });
    });
  }


  async getActivities() {
    this.activities = [];
    let result = [];
    let startend = this.startenddates(this.selectedDate ? this.selectedDate : new Date());

    let condition = [
      { condition: 'descending', field: 'createdAt' },
      { condition: 'limit', value: 5000 },
      { condition: 'include', value: 'updatedBy' },
      { condition: "equalTo", field: "moduleType", value: 'Sprint' },
      { condition: "containedIn", field: "updatedId", value: this.listOfSprintIds },
      { condition: "greaterThan", field: "createdAt", value: startend[0] },
      { condition: "lessThan", field: "createdAt", value: startend[1] },
    ]
    await this.queryInterface.executeQuery(this.parseService, 'ActivityCenter', condition).then(results => {
      results.forEach(async (element, index) => {
        let name;
        let queryInstance = this.parseService.instance.Object.extend('Sprint');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', element.get('updatedId'));
        await query.find().then(res => {
          let sprintResult = res[0];
          name = sprintResult.get('name');
        });
        result.push({
          message: element.get('message'),
          updatedBy: element.get('updatedBy').get('firstName') + ' ' + element.get('updatedBy').get('lastName'),
          createdAt: element.get('createdAt'),
          updatedUserImage: element.get('updatedBy').get('profileImageInfo').url,
          sprintName: name
        });
        this.activities = result.sort((a, b) => {
          if ((a.createdAt).getTime() > (b.createdAt).getTime()) { return -1; }
          if ((a.createdAt).getTime() < (b.createdAt).getTime()) { return 1; }
        });
      });
    });
  }

  async getWorkHours() {
    let startend = this.startenddates(this.selectedDate ? this.selectedDate : new Date());
    let timeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(timeSheet);
    query.include('user');
    query.include('user.profile');
    query.include('user.profile.department');
    query.greaterThan('createdAt', startend[0]);
    query.lessThan('createdAt', startend[1]);
    query.containedIn('user', this.membersIds);
    query.limit(1000000);
    await query.find().then(results => {
      let workDetails = [];
      this.membersIds.forEach(id => {
        let timeSheets = results.filter(x => x.get('user').id == id);
        let workHours = 0;
        let userName = '';
        if (timeSheets.length > 0) {
          timeSheets.forEach(tSheet => {
            let userProfile = tSheet.get('user').get('profile');
            userName = userProfile.get('firstName') + ' ' + userProfile.get('lastName');
            let totalAttendance = tSheet.get('totalAttendance');
            let workDatas = totalAttendance.project.filter(a => a.id == this.projectId);
            workDatas.forEach(workData => {
              workHours += workData.actualHours;
            });
          });
          if (workHours > 0) {
            workDetails.push({ position: 0, name: userName, id: id, workHours: workHours });
          }
        }
      });
      this.detailsToGraph(workDetails);
      this.workDetail = workDetails.sort(function (a, b) { return b.workHours - a.workHours });
      let totalHrs = 0;
      this.workDetail.forEach((element, index) => {
        element.position = index + 1;
        totalHrs += element.workHours;
        element.workHours = this.secondsToHms(Math.ceil(element.workHours / 1000));
      });
      this.totalWorkHours = this.secondsToHms(Math.ceil(totalHrs / 1000));
    });
  }

  detailsToGraph(workDetails) {
    let names = [];
    let workHrs = [];
    workDetails.forEach(element => {
      names.push(element.name);
      workHrs.push((Math.ceil(element.workHours / 1000) / 3600).toFixed(1));
    });
    this.graphValue = {
      labels: names,
      datasets: [
        {
          label: 'Work Hours',
          data: workHrs,
          backgroundColor: [
            '#9370DB',
            '#008080',
            '#999999',
            '#C7B42C',
            '#808000',
            '#5AA454',
            '#800080',
            '#FF00FF',
            '#000080',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ],
          hoverBackgroundColor: [
            '#9370DB',
            '#008080',
            '#999999',
            '#C7B42C',
            '#808000',
            '#5AA454',
            '#800080',
            '#FF00FF',
            '#000080',
            '#008080',
            '#00FFFF',
            '#FFC0CB',
            '#FF7F50',
            '#800000',
            '#333300'
          ]
        }]
    };
  }

  async getByDate() {
    this.getActivities();
    this.getWorkHours();
  }

  async last15DaysTab(event) {
    this.selectedDate = this.last15days[event];
    this.getActivities();
    this.getWorkHours();
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);
    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  Last15Days() {
    var result = [];
    for (var i = 0; i < 15; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(d);
    }
    this.last15days = result;
  }


}
